export default "__VITE_ASSET__D9GbO0pb__"